// ** Core API Import
import useApi from './api'

const { api } = useApi({})

export default api
